import { render } from "./DefaultLiabilityTypesList.vue?vue&type=template&id=61bc9933&scoped=true"
import script from "./DefaultLiabilityTypesList.vue?vue&type=script&lang=js"
export * from "./DefaultLiabilityTypesList.vue?vue&type=script&lang=js"

import "./DefaultLiabilityTypesList.vue?vue&type=style&index=0&id=61bc9933&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bc9933"]])

export default __exports__